import { Component, ElementRef, OnDestroy, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { Equipement } from "../../../models/equipement";
import { CarnetEquipement } from "../../../models/carnetEquipement";
import { EquipementMetadata } from "../../../models/equipementMetadata";
import { ActivatedRoute, Router } from "@angular/router";
import { LogementService } from "../../../services/logement.service";
import { EquipementService } from "../../../services/equipement.service";
import { UntypedFormBuilder } from "@angular/forms";
import { FormHelperService } from "../../../services/form-helper.service";
import { ToastService } from "../../../services/toast.service";
import { ExtraRouterService } from "../../../services/extra-router.service";
import { BackResourceService } from "../../../services/back-resource.service";
import { faCloudUploadAlt, faTrash } from '@fortawesome/free-solid-svg-icons';
import { Subscription } from "rxjs";
import { LoaderService } from "../../../services/loader.service";
import {ErrorService} from "../../../services/error.service";

@Component({
    selector: 'app-equipement-edit',
    templateUrl: './equipement-edit.component.html',
    styleUrls: ['./equipement-edit.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EquipementEditComponent implements OnInit, OnDestroy  {

  @ViewChild('imageInput')
  imageInput: ElementRef;

  @ViewChild('noticeInput')
  noticeInput: ElementRef;

  faTrash = faTrash;
  faCloudUploadAlt = faCloudUploadAlt;

  carnetEquipement$: Promise<CarnetEquipement>;
  metadata$: Promise<EquipementMetadata>;

  private logementId: number;
  private equipementId: number;

  notice = {
    metadata: '',
    file: null,
    isUpload: false,
  }

  image = {
    metadata: '',
    file: null
  }

  form = this.fb.group({
    reference: [],
    urlFabriquant: [],
    deleteNotice: [false],
    deleteImage: [false]
  });

  private subscription: Subscription;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    public extraRouter: ExtraRouterService,
    private logementService: LogementService,
    private equipementService: EquipementService,
    private fb: UntypedFormBuilder,
    private fh: FormHelperService,
    private toastService: ToastService,
    private backResource: BackResourceService,
    public loaderService: LoaderService,
    private errorService: ErrorService
  ) {
  }

  ngOnInit() {
    this.equipementId = parseInt(this.route.snapshot.paramMap.get('id'));

    this.subscription = this.logementService.logementCourant.subscribe(logement => {
      this.logementId = logement.id;
      this.carnetEquipement$ = this.equipementService.findDetailsById(this.logementId, this.equipementId);
      this.metadata$ = this.equipementService.getMetadata(this.logementId, this.equipementId);
      this.metadata$.then(metadata => {
        metadata = metadata || new EquipementMetadata();
        this.notice.metadata = metadata.notice && metadata.notice.url ? (this.backResource.getUrl(metadata.notice.url)) : '';
        this.notice.isUpload = this.notice.metadata !== '';
        this.image.metadata = metadata.image && metadata.image.url ? (this.backResource.getUrl(metadata.image.url)) : '';
        this.form.patchValue(metadata);
      });
    });
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  updateNotice(event) {
    const that = this;
    this.form.get('deleteNotice').setValue(false);
    if (event.target.files && event.target.files[0]) {
      const reader = new FileReader();
      this.notice.file = event.target.files[0];
      this.notice.isUpload = false;
      reader.onload = (e) => {
        that.notice.metadata = e.target.result as string;
      };
      reader.readAsDataURL(this.notice.file);
    }
  }

  deleteNotice() {
    this.notice.metadata = null;
    this.notice.isUpload = false;
    this.imageInput.nativeElement.value="";
    this.form.get('deleteNotice').setValue(true);
  }


  updateImage(event) {
    const that = this;
    this.form.get('deleteImage').setValue(false);
    if (event.target.files && event.target.files[0]) {
      const reader = new FileReader();
      this.image.file = event.target.files[0];

      reader.onload = (e) => {
        that.image.metadata = e.target.result as string;
      };
      reader.readAsDataURL(this.image.file);
    }
  }

  deleteImage() {
    this.image.metadata = null;
    this.imageInput.nativeElement.value="";
    this.form.get('deleteImage').setValue(true);
  }

  save() {
    const metadata = this.form.getRawValue();
    metadata.notice = {binaryContent: this.notice.file};
    metadata.image = {binaryContent: this.image.file};
    this.equipementService.saveMetadata(this.logementId, this.equipementId, metadata).then((response) => {
      if (response.status === 'error') {
        const errors = response.errors;
        this.errorService.toastErrors(errors);
      } else {
        this.toastService.show(response.message, {classname: 'toast-' + response.status});
        this.router.navigate([this.extraRouter.previousUrl || '/mes-equipements']);
      }
    });
  }
}
